<template>
  <div class="pl-4 pr-4">
    <b-collapse :id="`collapse-${postId}`">
      <div class="mb-4 comments-container" v-if="comments ? comments.length > 0 : 0">
        <div v-for="comment in comments" class="row comment-wrapper" :key="comment.id">
          <div class="col-md-12 caption py-2">
            <b-avatar
              variant="success"
              :text="comment.first_name ? comment.first_name.charAt(0) : ''"
              class="b-avatar mr-1"
            />
            <strong>{{ comment.display_name }}</strong>
          </div>
          <div class="col-md-12 caption">
            {{ comment.message }}
          </div>
          <div class="col-md-12 caption text-right text-gray py-1">
            {{ comment.date }}
          </div>
        </div>
      </div>
    </b-collapse>
    <div v-if="!disableSubmition">
      <b-form-textarea
        v-model="comment"
        :placeholder="trans('community.add_comment')"
        rows="3"
        max-rows="6"
      />
      <div class="d-flex justify-content-end pb-3">
        <b-button
          variant="outline-secondary"
          size="sm"
          class="mt-3"
          @click="submitComment"
          :disabled="comment.length === 0"
        >
          {{ trans("community.submit") }}
        </b-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CommentsBox",
  props: {
    comments: Array,
    postId: Number,
    disableSubmition: Boolean,
  },
  data() {
    return {
      comment: "",
      hasSubmited: false,
    };
  },
  methods: {
    submitComment() {
      if (!this.hasSubmited === true) {
        this.$root.$emit("bv::toggle::collapse", `collapse-${this.postId}`);
      }

      this.$emit("onCommentSubmit", { comment: this.comment, postId: this.postId });
      trackEvent("PublishTheComment", {});
      this.comment = "";
      this.hasSubmited = true;
    },
  },
};
</script>

<style scoped lang="scss">
.comments-container {
  max-height: 300px;
  overflow-y: auto;
  overflow-x: hidden;
}
.comment-wrapper {
  border-bottom: 1px solid $color-dark-600;
}
.text-gray {
  color: rgba($color-dark, 0.5);
}
.b-avatar {
  font-size: 0.7rem;
  width: 2rem !important;
  height: 2rem !important;
  color: $color-white;
  font-weight: bold;
}
</style>
